<section class="rounded-lg border border-primary-200 bg-primary-50 p-3">
  <!-- Header -->
  <div class="mb-3 flex items-start gap-3">
    <div
      class="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary-200"
    >
      <lucide-icon name="target" [size]="16" class="text-primary-500" />
    </div>
    <div class="min-w-0">
      <h4 class="text-paragraph-s-reg font-medium text-primary-900">
        {{ "reductionTips.objective.title" | transloco }}
      </h4>
      <p class="text-paragraph-xs-reg text-greyscale-600">
        {{ "reductionTips.objective.subtitle" | transloco }}
      </p>
    </div>
  </div>

  <!-- Ce voyage / objectif / écart -->
  <div class="mb-3 grid grid-cols-3 gap-2">
    <div class="rounded-lg border border-primary-200 bg-white p-2 text-center">
      <p class="text-paragraph-xs-reg text-greyscale-500">
        {{ "reductionTips.objective.thisTrip" | transloco }}
      </p>
      <p
        class="text-paragraph-s-reg font-semibold tabular-nums"
        [class]="statusTextClass()"
      >
        {{ objective().tripValue | formatCO2e }}
      </p>
      <p class="text-paragraph-xs-reg text-greyscale-500">
        /{{ "reductionTips.objective.perPerson" | transloco }}
      </p>
    </div>

    <div class="rounded-lg border border-primary-200 bg-white p-2 text-center">
      <p class="text-paragraph-xs-reg text-greyscale-500">
        {{ "reductionTips.objective.targetLabel" | transloco }}
      </p>
      <p
        class="text-paragraph-s-reg font-semibold tabular-nums text-primary-800"
      >
        {{ objective().targetValue | formatCO2e }}
      </p>
      <p class="text-paragraph-xs-reg text-greyscale-500">
        /{{ "reductionTips.objective.perPerson" | transloco }}
      </p>
    </div>

    <div class="rounded-lg border border-primary-200 bg-white p-2 text-center">
      <p class="text-paragraph-xs-reg text-greyscale-500">
        {{ "reductionTips.objective.difference" | transloco }}
      </p>
      <p
        class="text-paragraph-s-reg font-semibold tabular-nums"
        [class]="statusTextClass()"
      >
        {{ objective().isAboveTarget ? "+" : "-"
        }}{{ objective().differencePercent }}%
      </p>
    </div>
  </div>

  <!-- Barre : voyage vs marqueur objectif -->
  <div class="relative h-3 w-full rounded-full bg-greyscale-100">
    <div
      class="h-full rounded-l-full"
      [style.width.%]="barWidthPercent()"
      [class]="barColorClass()"
    ></div>
    <div
      class="absolute top-[-4px] h-[calc(100%+8px)] w-0.5 -translate-x-1/2 bg-primary-800"
      [style.left.%]="markerPercent()"
    ></div>
  </div>
  <p class="mt-1 text-right text-paragraph-xs-reg text-greyscale-500">
    ← {{ "reductionTips.objective.targetLabel" | transloco }} :
    {{ objective().targetValue | formatCO2e }}/{{
      "reductionTips.objective.perPerson" | transloco
    }}
  </p>
</section>
